module.exports = __webpack_public_path__ + "static/media/papeleria.78ae4f6e.svg";